import React from 'react';
import Carousel from '../components/Carousel';
import { usePageLastUpdated } from '../hooks/usePageLastUpdated';
import './EventsPage.css';

const PAGE_LAST_UPDATED = { dateTime: '2016-05-01', displayDate: 'May 1, 2016' };

const EventRow = ({ date, title, content }) => (
  <tr>
    <td className="date"></td>
    <td className="date" style={{ width: '100px' }}>
      {date}
    </td>
    <td>
      <p>
        <b>{title}</b>
      </p>
      <p>{content}</p>
    </td>
  </tr>
);

const YearRow = ({ year, id }) => (
  <tr>
    <td className="date" style={{ width: '50px' }}>
      <a id={id}>{year}</a>
    </td>
    <td colSpan="2" className="pub_link">
      <a href="#top">Go to top</a>
    </td>
  </tr>
);

const EventsPage = () => {
  usePageLastUpdated(PAGE_LAST_UPDATED);

  const carouselSlides = [
    {
      backgroundImage: '/images/banner_openstack_austin.png',
      content: (
        <>
          <p>
            The first{' '}
            <a href="https://www.openstack.org/summit/austin-2016/" title="Go to the summit." target="_blank" rel="noopener" className="external">
              OpenStack Summit
            </a>{' '}
            of 2016 was organized in Austin, Texas between April 25-29.
          </p>
          <p>
            At the week-long conference I presented a{' '}
            <a href="https://www.openstack.org/summit/austin-2016/summit-schedule/events/8827" title="See the summit session information." target="_blank" rel="noopener" className="external">
              technical session
            </a>{' '}
            on how to{' '}
            <a href="/events/openstackaustin2016.html" title="Download the slides" target="_blank" rel="noopener">
              containerize
            </a>{' '}
            your virtual network functions with{' '}
            <a href="https://www.openstack.org/" title="Go to the OpenStack project." target="_blank" rel="noopener" className="external">
              OpenStack
            </a>
            ,{' '}
            <a href="https://wiki.openstack.org/wiki/Neutron" title="Go to the Neutron project wiki." rel="noopener" className="external">
              Neutron
            </a>{' '}
            and{' '}
            <a href="https://www.midonet.org/" target="_blank" rel="noopener" className="external">
              MidoNet
            </a>
            .
          </p>
          <p>
            <a className="btn btn--primary" role="button" href="/events/openstackaustin2016.html" title="See the event.">
              See the event...
            </a>
          </p>
        </>
      ),
    },
    {
      backgroundImage: '/images/banner_openstack_tokyo.png',
      content: (
        <>
          <p>
            The second{' '}
            <a href="https://www.openstack.org/summit/tokyo-2015/" title="Go to the summit." target="_blank" rel="noopener" className="external">
              OpenStack Summit
            </a>{' '}
            of 2015 was organized in Tokyo, between October 27-30.
          </p>
          <p>
            The week-long conference is a great opportunity to connect with the{' '}
            <a href="https://www.openstack.org/" title="See the OpenStack project." target="_blank" rel="noopener" className="external">
              OpenStack
            </a>{' '}
            community, onboarding to{' '}
            <a href="https://www.openstack.org/community/" title="Check out the OpenStack community." target="_blank" rel="noopener" className="external">
              contributing
            </a>{' '}
            to the project, and{' '}
            <a href="https://www.openstack.org/summit/tokyo-2015/videos/" title="See the summit keynotes and talks." target="_blank" rel="noopener" className="external">
              learn
            </a>{' '}
            about the latest trends in cloud computing from project and industry leaders.
          </p>
          <p>
            <a className="btn btn--primary" role="button" href="/events/openstacktokyo2015.html" title="See the event.">
              See the event...
            </a>
          </p>
        </>
      ),
    },
    {
      backgroundImage: '/images/banner_openstack_cluj_15.png',
      content: (
        <>
          <p>
            How to virtualize the network for your{' '}
            <a href="https://www.openstack.org/" title="See the OpenStack project." target="_blank" rel="noopener" className="external">
              OpenStack
            </a>{' '}
            Cloud using{' '}
            <a href="https://www.midonet.org/" title="Check it out" target="_blank" rel="noopener" className="external">
              MidoNet
            </a>
            .
          </p>
          <p>
            An overview of OpenStack networking, a.k.a.{' '}
            <a href="https://wiki.openstack.org/wiki/Neutron" title="Check out Neutron." target="_blank" rel="noopener" className="external">
              Neutron
            </a>
            , of the various plugin options, and a deep-dive into the MidoNet SDN, presented at the{' '}
            <a href="https://www.meetup.com/OpenStackRomania/events/222910344/" title="See the meetup." target="_blank" rel="noopener" className="external">
              OpenStack Meetup
            </a>{' '}
            organized by our friends at{' '}
            <a href="https://www8.hp.com/ro/ro/software/cluj/" title="Go to HP web site." target="_blank" rel="noopener" className="external">
              HP
            </a>{' '}
            in Cluj-Napoca on October 1, 2015.
          </p>
          <p>
            <a className="btn btn--primary" role="button" href="/events/openstackcluj2015.html" title="See the event.">
              See the event...
            </a>
          </p>
        </>
      ),
    },
    {
      backgroundImage: '/images/banner_fosdem_15.png',
      content: (
        <>
          <p>The annual event for open-source software developers.</p>
          <p>
            At FOSDEM'15 organized in Brussels on January 30-31, 2015,{' '}
            <a href="https://twitter.com/kalymero_" title="Follow Antonio on Twitter" target="_blank" rel="noopener" className="external">
              Antonio Sagliocco
            </a>{' '}
            and I presented MidoNet 101: a beginner's introduction to the{' '}
            <a href="https://www.midonet.org/" title="Check it out" target="_blank" rel="noopener" className="external">
              MidoNet
            </a>{' '}
            SDN.
          </p>
          <p>
            <a className="btn btn--primary" role="button" href="/events/fosdem2015.html" title="See the event.">
              See the event...
            </a>
          </p>
        </>
      ),
    },
    {
      backgroundImage: '/images/banner_phd.png',
      content: (
        <>
          <p>
            I defended my doctoral dissertation, titled{' '}
            <a href="/research/phd/dissertation/index.html" title="Read my doctoral dissertation online.">
              Peer-to-Peer Television for the IP Multimedia Subsystem
            </a>
            , at{' '}
            <a href="https://www.uc3m.es/" title="Go the web site of the Carlos III University." target="_blank" rel="noopener" className="external">
              Carlos III University of Madrid
            </a>
            .
          </p>
          <p>
            The defense took place on July 18, 2012 at 11:00 AM in{' '}
            <a href="/research/phd/map/index.html" title="See the map with the location of my doctoral defense." target="_blank" rel="noopener">
              Aula de Grados
            </a>{' '}
            from the Padre Soler Building, Leganés Campus.
          </p>
          <p>
            <a className="btn btn--primary" role="button" href="/research/phd/index.html" title="Go to the page of my doctoral defense.">
              Go to the Defense Page
            </a>
          </p>
        </>
      ),
    },
  ];

  const events = [
    {
      year: '2013',
      id: 'p2013',
      items: [
        {
          date: 'October 4',
          title: 'Talk Announcement',
          content: (
            <>
              The talk <a href="/papers/imc2013.html">Rethinking PlanetLab for Internet Measurements</a> by{' '}
              <a href="https://www.nets.upf.edu/node/314" target="_blank" rel="noopener" className="external">
                Manuel Palacin
              </a>{' '}
              has been accepted in the News and Community Feedback Session of the{' '}
              <a href="https://conferences.sigcomm.org/imc/2013/" title="Go to the 2013 Internet Measurement Conference web site" target="_blank" rel="noopener" className="external">
                2013 Internet Measurement Conference
              </a>
              .
            </>
          ),
        },
        {
          date: 'June 20',
          title: 'Article Publication',
          content: (
            <>
              The paper <a href="/papers/jip2013.html">The Impact of Content Delivery Networks on the Internet Ecosystem</a> has been accepted for publication in the{' '}
              <a href="http://jip.vmhost.psu.edu/ojs/index.php/jip/" title="Go to the Journal of Information Policy home page" target="_blank" rel="noopener" className="external">
                Journal of Information Policy
              </a>{' '}
              by{' '}
              <a href="http://jip.vmhost.psu.edu/ojs/" title="Go to the Open Journals System home page" target="_blank" rel="noopener" className="external">
                Open Journals System
              </a>
              .
            </>
          ),
        },
        {
          date: 'February 18',
          title: 'We Are Hiring Junior Research Engineers',
          content: (
            <>
              <a href="https://www.nets.upf.edu/" title="Check out the NeTS group web site." target="_blank" rel="noopener" className="external">
                We
              </a>{' '}
              are seeking highly dynamic individuals for a challenging project: designing, implementing and testing communication protocols for mesh and wireless sensor (WSN) networks, in the framework of two applied research projects, focused on the management of wandering patients, and on domestic and industrial energy management, respectively.{' '}
              <a href="https://www.nets.upf.edu/openings/" title="Go to the NeTS recruiting web page." target="_blank" rel="noopener" className="external">
                Check out the details and apply.
              </a>
            </>
          ),
        },
      ],
    },
    {
      year: '2012',
      id: 'p2012',
      items: [
        {
          date: 'July 18',
          title: 'Doctoral Defense',
          content: (
            <>
              The defense of my <a href="/research/phd/index.html" title="Go to the web page of my doctoral dissertation.">doctoral dissertation</a>, titled{' '}
              <a href="/research/phd/dissertation/index.html" title="Read my doctoral dissertation online.">Peer-to-Peer Television for the IP Multimedia Subsystem</a>, which will take place at 11:00 AM in{' '}
              <a href="/research/phd/map/index.html" title="View the map." target="_blank" rel="noopener">
                Aula de Grados
              </a>{' '}
              from the Leganés campus of{' '}
              <a href="https://www.uc3m.es/" title="Go to the web site of the Carlos III University." target="_blank" rel="noopener" className="external">
                Carlos III University
              </a>
              .
            </>
          ),
        },
        {
          date: 'May 11',
          title: 'Invited Reviewer',
          content: (
            <>
              Invited external reviewer at an internal{' '}
              <a href="https://www.nets.upf.edu/node/377/" title="Check out the workshop web page." target="_blank" rel="noopener" className="external">
                workshop
              </a>{' '}
              by the{' '}
              <a href="https://www.nets.upf.edu/" title="Go to web site of the NeTS research group." target="_blank" rel="noopener" className="external">
                NeTS
              </a>{' '}
              research group of{' '}
              <a href="https://www.upf.edu/" title="Go to the web site of Pompeu Fabra University." target="_blank" rel="noopener" className="external">
                Universitat Pompeu Fabra
              </a>
              .
            </>
          ),
        },
        {
          date: 'May 10',
          title: 'Invited Speaker',
          content: (
            <>
              Invited speaker by the{' '}
              <a href="https://www.nets.upf.edu/" title="Go to web site of the NeTS research group." target="_blank" rel="noopener" className="external">
                NeTS
              </a>{' '}
              research group at{' '}
              <a href="https://www.upf.edu/" title="Go to the web site of Pompeu Fabra University." target="_blank" rel="noopener" className="external">
                Universitat Pompeu Fabra
              </a>
              , with a{' '}
              <a href="/download/UPFTalk20120509Slides.pptx" title="Download the slides of my talk.">talk</a> on peer-to-peer television in next generation networks.
            </>
          ),
        },
        {
          date: 'January 19',
          title: 'Invitation to Join Editorial Board',
          content: (
            <>
              Invited to the editorial board of the{' '}
              <a href="https://www.iariajournals.org/networks_and_services/index.html" target="_blank" rel="noopener" className="external">
                International Journal on Advances in Networks and Services
              </a>
              .
            </>
          ),
        },
      ],
    },
    {
      year: '2011',
      id: 'p2011',
      items: [
        {
          date: 'July 4',
          title: 'Invitation to Technical Program Committee',
          content: (
            <>
              Invited as a technical program committee member to the{' '}
              <a href="https://www.iaria.org/conferences2012/ICNS12.html" target="_blank" rel="noopener" className="external">
                Eighth International Conference on Networking and Services
              </a>{' '}
              organized by <a href="https://www.iaria.org/" target="_blank" rel="noopener">IARIA</a> in St. Maarten, Netherlands Antilles between 25th and 29th of March 2012. Check out the{' '}
              <a href="https://www.iaria.org/conferences2012/CfPICNS12.html" target="_blank" rel="noopener" className="external">
                call for papers
              </a>{' '}
              or{' '}
              <a href="https://www.iaria.org/conferences2012/SubmitICNS12.html" target="_blank" rel="noopener" className="external">
                submit a paper
              </a>
              .
            </>
          ),
        },
        {
          date: 'February 8',
          title: 'Software Release',
          content: (
            <>
              <a href="/projects/simworker/index.html">SimWorker</a>, a C++ library for parallel execution in simulation environments is now available online.
            </>
          ),
        },
      ],
    },
    {
      year: '2010',
      id: 'p2010',
      items: [
        {
          date: 'December 16',
          title: 'Article Publication',
          content: (
            <>
              The paper <a href="/papers/comnet2011.html">P2P vs. IP Multicast: Comparing Approaches to IPTV Streaming Based on TV Channel Popularity</a> has been accepted for publication in{' '}
              <a href="https://www.elsevier.com/locate/comnet" title="Go to Computer Networks home page" target="_blank" rel="noopener" className="external">
                Computer Networks
              </a>{' '}
              by <a href="https://www.elsevier.com" title="Go to Elsevier home page" target="_blank" rel="noopener" className="external">Elsevier</a>.
            </>
          ),
        },
        {
          date: 'December 16',
          title: 'Software Release',
          content: (
            <>
              <a href="/projects/simstream/index.html">SimStream</a>, a C++-based efficient network simulator for large-scale streaming applications is now available online.
            </>
          ),
        },
        {
          date: 'September 13',
          title: 'Call for Papers',
          content: (
            <>
              Consider to contribute and/or forward to the appropriate groups the opportunity to submit and publish original scientific results in the{' '}
              <a href="https://www.iaria.org/conferences2011/CfPICNS11.html" target="_blank" rel="noopener" className="external">
                Seventh International Conference on Networking and Services
              </a>
              , May 22-27, 2011 in Venice, Italy.
            </>
          ),
        },
        {
          date: 'May 18',
          title: 'Invitation to Technical Program Committee',
          content: (
            <>
              Invited as a technical program committee member to the{' '}
              <a href="https://www.iaria.org/conferences2011/ICNS11.html" target="_blank" rel="noopener" className="external">
                Seventh International Conference on Networking and Services
              </a>{' '}
              organized by <a href="https://www.iaria.org/" target="_blank" rel="noopener">IARIA</a> in Venice, Italy between 22nd and 27th of May 2011. Check out the{' '}
              <a href="https://www.iaria.org/conferences2011/CfPICNS11.html" target="_blank" rel="noopener" className="external">
                call for papers
              </a>{' '}
              or{' '}
              <a href="https://www.iaria.org/conferences2011/SubmitICNS11.html" target="_blank" rel="noopener" className="external">
                submit a paper
              </a>
              .
            </>
          ),
        },
        {
          date: 'May 14',
          title: 'Article Publication',
          content: (
            <>
              The paper <a href="/papers/comcom2010.html">Supporting mobility in an IMS-based P2P IPTV service: a Proactive Context Transfer mechanism</a> is published online in{' '}
              <a href="https://www.elsevier.com/locate/comcom" target="_blank" rel="noopener" className="external">
                Computer Communications
              </a>{' '}
              by <a href="https://www.elsevier.com/" target="_blank" rel="noopener" className="external">Elsevier</a>.
            </>
          ),
        },
        {
          date: 'February 16',
          title: 'Seminar Announcement',
          content: (
            <>
              <a href="/download/IMDEASeminar2Slides.pptx" target="_blank" rel="noopener">Download</a> the slides presented at the{' '}
              <a href="https://networks.imdea.org" target="_blank" rel="noopener" className="external">
                IMDEA Networks
              </a>
              /<a href="https://www.it.uc3m.es/~netcom/" target="_blank" rel="noopener" className="external">NETCOM</a> networking seminar.
            </>
          ),
        },
      ],
    },
    {
      year: '2009',
      id: 'p2009',
      items: [
        {
          date: 'December 21',
          title: 'Article Publication',
          content: (
            <>
              The paper <a href="/papers/ieeenetwork2009.html">Enabling layered video coding for IMS-based IPTV home services</a> is published in{' '}
              <a href="https://www.comsoc.org/ni/" target="_blank" rel="noopener" className="external">
                IEEE Network
              </a>
              .
            </>
          ),
        },
        {
          date: 'October 16',
          title: 'Research Material Release',
          content: (
            <>
              The slides for <a href="/papers/ap2ps2009.html">FLaCoSt: A Novel Peer to Peer Architecture for Video Streaming in a Next Generation Network</a> presented at the first{' '}
              <a href="https://www.iaria.org/" className="external">IARIA</a>{' '}
              <a href="https://www.iaria.org/conferences2009/AP2PS09.html" className="external">
                International Conference on Advances in P2P Systems
              </a>{' '}
              are now available online.
            </>
          ),
        },
        {
          date: 'October 11-15',
          title: 'Conference Attendance',
          content: (
            <>
              Attending to the First <a href="https://www.iaria.org/">IARIA</a>{' '}
              <a href="https://www.iaria.org/conferences2009/AP2PS09.html" className="external">
                International Conference on Advances in P2P Systems
              </a>{' '}
              and presenting <a href="/papers/ap2ps2009.html">FLaCoSt: A Novel Peer to Peer Architecture for Video Streaming in a Next Generation Network</a>.
            </>
          ),
        },
        {
          date: 'September 17',
          title: 'Article Publication',
          content: (
            <>
              The paper <a href="/papers/ijcs2009.html">A peer-to-peer IPTV service architecture for the IP multimedia subsystem</a> is published{' '}
              <a href="https://dx.doi.org/10.1002/dac.1063" target="_blank" rel="noopener" className="external">
                online
              </a>{' '}
              by John Wiley &amp; Sons.
            </>
          ),
        },
        {
          date: 'August 16',
          title: 'Invitation to Technical Program Committee',
          content: (
            <>
              Invited as a{' '}
              <a href="https://www.iaria.org/conferences2010/ComICNS10.html" target="_blank" rel="noopener" className="external">
                technical program committee
              </a>{' '}
              member to the{' '}
              <a href="https://www.iaria.org/conferences2010/ICNS10.html" target="_blank" rel="noopener" className="external">
                Sixth International Conference on Networking and Services
              </a>{' '}
              organized by <a href="https://www.iaria.org/" target="_blank" rel="noopener">IARIA</a> in Cancun, Mexico between 7th and 13th of March 2010. Check out the{' '}
              <a href="https://www.iaria.org/conferences2010/CfPICNS10.html" target="_blank" rel="noopener" className="external">
                call for papers
              </a>{' '}
              or{' '}
              <a href="https://www.iaria.org/conferences2010/SubmitICNS10.html" target="_blank" rel="noopener" className="external">
                submit a paper
              </a>
              .
            </>
          ),
        },
        {
          date: 'August 1',
          title: 'Article Publication',
          content: (
            <>
              The paper <a href="/papers/ijcs2009.html">A peer-to-peer IPTV service architecture for the IP multimedia subsystem</a> has been accepted for publication in the{' '}
              <a href="https://www3.interscience.wiley.com/journal/117946196/grouphome/home.html" title="Go to IJCS home page" target="_blank" rel="noopener" className="external">
                International Journal of Communication Systems
              </a>{' '}
              by <a href="https://www.wiley.com/" title="Go to Wiley home page" target="_blank" rel="noopener" className="external">John Wiley &amp; Sons, Ltd</a>.
            </>
          ),
        },
        {
          date: 'April 20-24',
          title: 'Conference Announcement',
          content: (
            <>
              The{' '}
              <a href="https://www.iaria.org/conferences2009/ICNS09.html" target="_blank" rel="noopener" className="external">
                5th International Conference on Networking and Services
              </a>{' '}
              in València, Spain.
            </>
          ),
        },
        {
          date: 'February 20',
          title: 'Call for Applicants',
          content: (
            <>
              Deadline for receiving applications for{' '}
              <a href="https://www.networks.imdea.org/People/PostdoctoralandStudents/tabid/2181/Default.aspx" target="_blank" rel="noopener noreferrer" className="external">
                research assistant
              </a>{' '}
              positions at <a href="https://www.networks.imdea.org/" className="external">IMDEA Networks</a>. Take a look at the{' '}
              <a href="https://www.networks.imdea.org/OpenPositions/PhDGrants/tabid/1269/Default.aspx" target="_blank" rel="noopener noreferrer" className="external">
                call details
              </a>{' '}
              and future key dates in the selection process.
            </>
          ),
        },
        {
          date: 'February 15-18',
          title: 'Meeting Announcement',
          content: (
            <>
              The{' '}
              <a href="https://www.kom.tu-darmstadt.de/en/events/special-events/9th-content-plenary-meeting/home/" target="_blank" rel="noopener noreferrer" className="external">
                9th plenary meeting
              </a>{' '}
              for the{' '}
              <a href="https://www.ist-content.eu/" target="_blank" rel="noopener" className="external">
                CONTENT Network of Excellence
              </a>
              , organized by the{' '}
              <a href="https://www.kom.tu-darmstadt.de/" target="_blank" rel="noopener" className="external">
                Multimedia Communications Lab
              </a>{' '}
              from the{' '}
              <a href="https://www.tu-darmstadt.de/" target="_blank" rel="noopener" className="external">
                Technical University of Darmstadt
              </a>
              .
            </>
          ),
        },
      ],
    },
  ];

  return (
    <>
      <Carousel slides={carouselSlides} />
      <div className="events-page" id="top">
        <p>
          <a className="btn btn--default" role="button" href="/events.xml" type="application/rss+xml" rel="alternate noopener" title="Alex Bikfalvi news and events RSS Feed." target="_blank">
            Subscribe to the RSS Feed
          </a>
        </p>

        <h3>
          <a href="#p2009">2009</a> | <a href="#p2010">2010</a> | <a href="#p2011">2011</a> | <a href="#p2012">2012</a> | <a href="#p2013">2013</a>
        </h3>

        <table className="publication padding-4px align-top">
          <tbody>
            {events.map((group) => (
              <React.Fragment key={group.id}>
                <YearRow year={group.year} id={group.id} />
                {group.items.map((item, i) => (
                  <EventRow key={`${group.id}-${i}`} {...item} />
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default EventsPage;
